import { useState, useCallback } from "react";
import { db } from "../services/firebase";
import { ref, push, update } from "firebase/database";


export default function useCreateQuestion() {

    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const createOrUpdateQuestion = useCallback(

        async (domainId, categoryId, data, questionId = null) => {

            if (!domainId) {
                throw new Error("Domain ID is required");
            }

            if (!categoryId) {
                throw new Error("Category ID is required");
            }

            if (!data?.question?.trim()) {
                setError("Question text is required");
                return { success: false };
            }

            setSaving(true);
            setError(null);

            try {
                let id = questionId;

                if (!id) {
                    id = push(ref(db, `Questions/AllQuestions/${domainId}`)).key;
                }

                const payload = {
                    questionNumber: data.questionNumber?.trim() || null,
                    orderId: data.orderId ? parseInt(data.orderId, 10) : Date.now(),
                    question: data.question.trim(),
                    detailedAnswer: data.detailedAnswer?.trim() || "",
                    compactAnswer: data.compactAnswer?.trim() || "",
                    prompt: data.prompt?.trim() || "",
                };

                const updates = {};
                updates[`Questions/AllQuestions/${domainId}/${id}`] = payload;
                updates[`Questions/CategoryQuestions/${domainId}/${categoryId}/${id}`] = payload;
                await update(ref(db), updates);

                return { success: true, id };

            } catch (err) {
                console.error("❌ Error saving question:", err);
                setError("Failed to save question. Please try again.");
                return { success: false };
            } finally {
                setSaving(false);
            }
        },
        []
    );

    return { createOrUpdateQuestion, saving, error };
}
